<template>
    <div class="navigation">
        <ul class="ul-c">
            <li><button class='btn' @click="change_show_content('description')">介绍</button></li>
            <li><button class='btn' @click="change_show_content('question')">讨论</button></li>
            <li><button class='btn' @click="change_show_content('summary')">心得</button></li>
        </ul>
    </div>
</template>
<script type="text/javascript">
import { mapState,mapActions } from 'vuex'


export default {
    components: {

    },
    methods: {
        ...mapActions({
          change_show_content: 'learning/change_show_content',
        })
    }
}

</script>
<style type="text/css" scoped>
.navigation{
    width:100px;
    height:100%;
    float:left;
    /*background-color: #66CCFF;*/
}
.ul-c{
margin-left:-18px;
}
.btn{
padding-top: 30px;
padding-bottom: 30px;
}
</style>